const Config = {
    genAIEnabled : true,
    matomoURL : 'https://dev-trk.testmaya.com/',
    matomoSiteID: 9
};

export default Config